import './DuvalVisualization.scss';

export { schema, getSchema, uiSchema } from '../../schemas/DuvalVisualizationSchema';

export { default } from './DuvalVisualization';
